import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IResponseWithData } from '../interfaces';
import { GenerateAIResponseBody } from '../interfaces/ai.interface';


@Injectable({
  providedIn: 'root',
})
export class AiService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  saveAiSettings(payload: any) {
    return this.http.post<any>(environment.baseURL + '/ai/settings', payload)
      .pipe(map(res => res.data));
  }

  getAiSettings() {
    return this.http.get<any>(environment.baseURL + '/ai/settings')
      .pipe(map(res => res.data));
  }

  generateAIResponse(payload: GenerateAIResponseBody): Observable<string> {
    return this.http.post<IResponseWithData<string>>(environment.baseURL + '/ai/response', payload)
      .pipe(map(res => res.data));
  }
}

